import { render } from "./IndexFooter.vue?vue&type=template&id=31a65dde"
const script = {}

import exportComponent from "/home/misserver/Documents/akred/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__